import ExpandableActivityController from '../../../../javascript/stimulusControllers/shared/expandable-activity-controller';

export default class extends ExpandableActivityController {
  clearPopup() {
    this.expandedContentContainerTarget.innerHTML = '';
    this.isExpanded = false;
  }
};



// WEBPACK FOOTER //
// ./app/components/popups/assets/javascript/popup-data-link-controller.js